import React from 'react';
import { MdDelete } from 'react-icons/md';

// Handle changes to the delimiter for SideA or SideB
export const handleDelimiterChange = (fieldName, side, newValue, setFieldsConfig) => {
    console.log('setFieldsConfig:', typeof setFieldsConfig);
    setFieldsConfig(prevFieldsConfig => {
        console.log('Updating:', fieldName, side, newValue);
        const updatedFieldsConfig = { ...prevFieldsConfig };
        const multiTransformations = updatedFieldsConfig[fieldName]?.multiTransformations || {
            delimiter: { sideA: '', sideB: '' },
        };
        multiTransformations.delimiter[side] = newValue;
        updatedFieldsConfig[fieldName] = { ...updatedFieldsConfig[fieldName], multiTransformations };
        return updatedFieldsConfig;
    });
};


// Multi Transformations Section
export const DelimiterSection = ({ fieldName, fieldsConfig, handleDelimiterChange }) => (
    <div className="delimiter-section" style={{ display: 'flex', gap: '1rem' }}>
        <div>
            <label>SideA Delimiter:</label>
            <input
                type="text"
                value={fieldsConfig[fieldName]?.multiTransformations?.delimiter?.sideA || ''}
                placeholder="Enter delimiter for SideA"
                onChange={(e) => handleDelimiterChange(fieldName, 'sideA', e.target.value)}
            />
        </div>
        <div>
            <label>SideB Delimiter:</label>
            <input
                type="text"
                value={fieldsConfig[fieldName]?.multiTransformations?.delimiter?.sideB || ''}
                placeholder="Enter delimiter for SideB"
                onChange={(e) => handleDelimiterChange(fieldName, 'sideB', e.target.value)}
            />
        </div>
    </div>
);

export const handleMultiMappingChange = (
    fieldName,
    index,
    type,
    newValue,
    setFieldsConfig,
    parentField,
    side
) => {
    setFieldsConfig(prevFieldsConfig => {
        const updatedFieldsConfig = { ...prevFieldsConfig };
        const multiMappings = updatedFieldsConfig[parentField]?.multiTransformations?.[side]?.[fieldName]?.mappings || [];
        if (multiMappings[index]) {
            multiMappings[index] = { ...multiMappings[index], [type]: newValue };
        }
        updatedFieldsConfig[parentField].multiTransformations[side][fieldName].mappings = multiMappings;
        return updatedFieldsConfig;
    });
};

export const addNewMultiRow = (fieldName, setFieldsConfig, parentField, side) => {
    setFieldsConfig(prevFieldsConfig => {
        // Clone the previous state to avoid mutations
        const updatedFieldsConfig = { ...prevFieldsConfig };

        // Extract current mappings or initialize if undefined
        const currentMappings =
            updatedFieldsConfig[parentField]?.multiTransformations?.[side]?.[fieldName]?.mappings || [];

        // Guard clause: Check if the last row is empty, but skip if it's the first addition
        if (currentMappings.length > 0) {
            const lastMapping = currentMappings[currentMappings.length - 1];
            if (!lastMapping.key && !lastMapping.value) {
                console.log('Cannot add a new row. Please fill out the current row before adding another.');
                return prevFieldsConfig; // Return unchanged state
            }
        }

        // Add a new mapping row
        const multiMappings = [...currentMappings, { key: '', value: '' }];

        // Ensure the structure exists before assigning
        if (!updatedFieldsConfig[parentField]) {
            updatedFieldsConfig[parentField] = { multiTransformations: {} };
        }
        if (!updatedFieldsConfig[parentField].multiTransformations) {
            updatedFieldsConfig[parentField].multiTransformations = {};
        }
        if (!updatedFieldsConfig[parentField].multiTransformations[side]) {
            updatedFieldsConfig[parentField].multiTransformations[side] = {};
        }
        if (!updatedFieldsConfig[parentField].multiTransformations[side][fieldName]) {
            updatedFieldsConfig[parentField].multiTransformations[side][fieldName] = { mappings: [] };
        }

        // Update the mappings
        updatedFieldsConfig[parentField].multiTransformations[side][fieldName].mappings = multiMappings;

        return updatedFieldsConfig;
    });
};


export const deleteMultiRow = (fieldName, index, setFieldsConfig, parentField, side) => {
    setFieldsConfig(prevFieldsConfig => {
        const updatedFieldsConfig = { ...prevFieldsConfig };
        const multiMappings = updatedFieldsConfig[parentField]?.multiTransformations?.[side]?.[fieldName]?.mappings || [];
        const updatedMappings = multiMappings.filter((_, mapIndex) => mapIndex !== index);
        updatedFieldsConfig[parentField].multiTransformations[side][fieldName].mappings = updatedMappings;
        return updatedFieldsConfig;
    });
};

export const MultiMappingsSection = ({
    fieldName,
    fieldsConfig,
    handleMultiMappingChange,
    addNewMultiRow,
    deleteMultiRow,
    parentField,
    setFieldsConfig,
}) => {
    const sideAFields =
        fieldsConfig[parentField]?.multiTransformations?.sideA || {};
    const sideBFields =
        fieldsConfig[parentField]?.multiTransformations?.sideB || {};

    return (
        <div className="multi-mappings-section">
            <div className="multi-mappings-fields">
                {/* SideA Fields */}
                <div className="field-group">
                    <h5>SideA Fields</h5>
                    {Object.keys(sideAFields).map((subField, index) => (
                        <div key={index}>
                            <h6>{subField}</h6>
                            {(sideAFields[subField]?.mappings || []).map(
                                (mapping, mapIndex) => (
                                    <div
                                        key={mapIndex}
                                        className="mapping-item"
                                    >
                                        <input
                                            type="text"
                                            value={mapping.key || ''}
                                            placeholder="Side A"
                                            onChange={(e) =>
                                                handleMultiMappingChange(
                                                    subField,
                                                    mapIndex,
                                                    'key',
                                                    e.target.value,
                                                    setFieldsConfig,
                                                    parentField,
                                                    'sideA'
                                                )
                                            }
                                        />
                                        <input
                                            type="text"
                                            value={mapping.value || ''}
                                            placeholder="Side B"
                                            onChange={(e) =>
                                                handleMultiMappingChange(
                                                    subField,
                                                    mapIndex,
                                                    'value',
                                                    e.target.value,
                                                    setFieldsConfig,
                                                    parentField,
                                                    'sideA'
                                                )
                                            }
                                        />
                                        <button
                                            onClick={() =>
                                                deleteMultiRow(
                                                    subField,
                                                    mapIndex,
                                                    setFieldsConfig,
                                                    parentField,
                                                    'sideA'
                                                )
                                            }
                                        >
                                            <MdDelete />
                                        </button>
                                    </div>
                                )
                            )}
                            <button
                                className="add-button"
                                onClick={() =>
                                    addNewMultiRow(
                                        subField,
                                        setFieldsConfig,
                                        parentField,
                                        'sideA'
                                    )
                                }
                            >
                                Add MultiMapping
                            </button>
                        </div>
                    ))}
                </div>

                {/* SideB Fields */}
                <div className="field-group">
                    <h5>SideB Fields</h5>
                    {Object.keys(sideBFields).map((subField, index) => (
                        <div key={index}>
                            <h6>{subField}</h6>
                            {(sideBFields[subField]?.mappings || []).map(
                                (mapping, mapIndex) => (
                                    <div
                                        key={mapIndex}
                                        className="mapping-item"
                                    >
                                        <input
                                            type="text"
                                            value={mapping.key || ''}
                                            placeholder="Side A"
                                            onChange={(e) =>
                                                handleMultiMappingChange(
                                                    subField,
                                                    mapIndex,
                                                    'key',
                                                    e.target.value,
                                                    setFieldsConfig,
                                                    parentField,
                                                    'sideB'
                                                )
                                            }
                                        />
                                        <input
                                            type="text"
                                            value={mapping.value || ''}
                                            placeholder="Side B"
                                            onChange={(e) =>
                                                handleMultiMappingChange(
                                                    subField,
                                                    mapIndex,
                                                    'value',
                                                    e.target.value,
                                                    setFieldsConfig,
                                                    parentField,
                                                    'sideB'
                                                )
                                            }
                                        />
                                        <button
                                            onClick={() =>
                                                deleteMultiRow(
                                                    subField,
                                                    mapIndex,
                                                    setFieldsConfig,
                                                    parentField,
                                                    'sideB'
                                                )
                                            }
                                        >
                                            <MdDelete />
                                        </button>
                                    </div>
                                )
                            )}
                            <button
                                className="add-button"
                                onClick={() =>
                                    addNewMultiRow(
                                        subField,
                                        setFieldsConfig,
                                        parentField,
                                        'sideB'
                                    )
                                }
                            >
                                Add MultiMapping
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
